import { useEffect, useRef, useState } from 'react';
import { useTonAddress, useTonWallet as useTonConnectWallet } from '@tonconnect/ui-react';
import { ConnectButton } from '../components/ConnectButton';
import { connectWallet, disconnectWallet } from '../lib/api';

export function WalletRoute() {
  const addr = useTonAddress();
  const tcWallet = useTonConnectWallet();
  const [copied, setCopied] = useState(false);

  // CC-057 — sync the TonConnect connection state into users.ton_address
  // on the backend. TonConnect keeps the address only in client state;
  // without this the DB column stays NULL and recipient-fee routing falls
  // back to BLINKR_TEMP_CUSTODY. Fires once per address change (not on
  // every render) — `lastSyncedRef` dedupes repeated effect runs.
  const lastSyncedRef = useRef<string | null>(null);
  useEffect(() => {
    const next = addr || null;
    if (lastSyncedRef.current === next) return;
    lastSyncedRef.current = next;
    const op = next ? connectWallet(next) : disconnectWallet();
    // Background sync — a transient failure must not break the UI.
    op.catch(() => {
      // Allow a retry on the next effect run if the sync failed.
      lastSyncedRef.current = null;
    });
  }, [addr]);

  const onCopy = () => {
    if (!addr) return;
    navigator.clipboard?.writeText(addr).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  // CC-027 followup: open @wallet via Blinkr's referral link.
  // openTelegramLink is the correct Mini App API for t.me/* URLs.
  const openWallet = () => {
    const url = 'https://t.me/wallet/start?startapp=ref-1-632_C0EN8Sc';
    const tg = window.Telegram?.WebApp;
    if (tg && typeof tg.openTelegramLink === 'function') {
      tg.openTelegramLink(url);
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <div className="container vgap-16">
      <h1 style={{ margin: 0, fontSize: 22 }}>Кошелёк</h1>

      {!tcWallet || !addr ? (
        <div className="card vgap-12">
          <div>Подключи TON-кошелёк, чтобы покупать, продавать и управлять токенами.</div>
          <div className="muted" style={{ fontSize: 13 }}>
            Рекомендуем <strong>@wallet</strong> (встроен в Telegram).
            Tonkeeper, Tonhub и другие тоже работают.
          </div>
          <ConnectButton />
        </div>
      ) : (
        <div className="card vgap-12">
          <div className="muted" style={{ fontSize: 12 }}>Подключённый адрес</div>
          <div
            style={{
              fontFamily: 'ui-monospace, Menlo, monospace',
              fontSize: 13,
              wordBreak: 'break-all',
            }}
          >
            {addr}
          </div>
          <div className="muted" style={{ fontSize: 12 }}>
            Кошелёк: {tcWallet.device.appName}
          </div>
          <div className="row hgap-8">
            <button onClick={onCopy} className="secondary" style={{ flex: 1 }}>
              {copied ? '✓ Скопировано' : 'Копировать адрес'}
            </button>
            <button onClick={openWallet} style={{ flex: 1 }}>
              Перейти в @wallet
            </button>
          </div>
          <ConnectButton />
        </div>
      )}
    </div>
  );
}
